import { render, staticRenderFns } from "./CandidateEvaluation.vue?vue&type=template&id=045f2386&"
import script from "./CandidateEvaluation.vue?vue&type=script&lang=js&"
export * from "./CandidateEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports